export const reportYaml = () => `reports:
- id: "||VARIABLE_KEY_id||"
  name: "||VARIABLE_KEY_name||"
  type: Negative
  mode: Full
  shortDescription: |-
    ## Short overview of the issue
  description: |-
    ## Overview
      - we have this
      - we have that
    ## Issues in this report
    ### SKU mismatches
    #### Summary
      - Describes the issue
    #### Reason
      - Because of reason 1
      - Because of reason 2
      - ...
    #### How to fix?
      - Fix the SKU name in both systems to exactly the same with case-sensitive
      - Do A
      - Do B
      - ...
  tableName: "||VARIABLE_KEY_tableName||"
  tableId: "||VARIABLE_KEY_tableId||"
  reportSql: |-
    -- please alias all the return fields
    -- so that hexasync-cli can understands the fields
    select 
     v1.sku as sku,
     v1.price as source_price,
     v2.price as destination_price,
     -- must have issue and reason
     'Price not matched' as issue,
     'The product is not synced because X' as reason
    from __hss_the_task_table2 v1
    left join __hss_the_task_table2 v2 on v2.sku = v1.sku
    where 
      -- params @updated_at is from arguments
      v1.last_modified_on >= ts_to_date_string(@updated_at)
      -- params @sku, @price is from previous query
      and (v1.sku, v1.price) > (@sku, @price)
    order by sku, price
  arguments:
    updated_at: '{{last_updated.__updated_at}}'
  preparationStatements:
    last_updated:
      index: 0
      arguments: {}
      sql: |-
        -- get last date (-1 day)
        select __updated_at - (60*60*24*1000)
        from "||VARIABLE_KEY_tableName||"
        order by __updated_at desc
        limit 1;
`;
